export enum SortFilterOption {
  LATEST = "Latest",
  ANSWERED = "Answered",
  UNANSWERED = "Unanswered",
}
